import React from 'react';
import { Link } from 'react-router-dom';
import '../BreadCrumb/BreadCrumb.css';

const Index = ({ pageName, pageUrl, _parentClass, pageChildName, subChild, titleName, titleUrl }) => {
  const formattedPageName = pageName?.replace(/-/g, ' ') || '';
  const formattedPageChildName = pageChildName?.replace(/-/g, ' ') || '';

  return (
    <div className={`pagebreadcumb mt-2 ${_parentClass || ''}`}>
      <ul className='d-flex'>
        <li><Link to='/'>Home</Link></li>

        {formattedPageName && (
          <li>
            {pageUrl ? <Link to={pageUrl}>{formattedPageName}</Link> : <span>{formattedPageName}</span>}
          </li>
        )}

        {titleName && (
          <li>
            {titleUrl ? <Link to={titleUrl}>{titleName}</Link> : <span>{titleName}</span>}
          </li>
        )}

        {formattedPageChildName && <li>{formattedPageChildName}</li>}

        {subChild && <li>{subChild}</li>}
      </ul>
    </div>
  );
};

export default Index;
